// extracted by mini-css-extract-plugin
export var root = "PlasmicLogo-module--root--zzRhR";
export var root___focusVisibleWithin = "PlasmicLogo-module--root___focusVisibleWithin--eqhTF";
export var svg = "PlasmicLogo-module--svg--SD3AM";
export var svg___focusVisibleWithin = "PlasmicLogo-module--svg___focusVisibleWithin--NX6zw";
export var twentytwo = "PlasmicLogo-module--twentytwo--0w3DM";
export var twentytwoglobal_mode_dark = "PlasmicLogo-module--twentytwoglobal_mode_dark--vNXEG";
export var twentytwoneon = "PlasmicLogo-module--twentytwoneon--C2ymr";
export var twentytwo___focusVisibleWithin = "PlasmicLogo-module--twentytwo___focusVisibleWithin--1XI0l";